import { Children, ReactNode, useEffect } from 'react';
import { KeenSliderInstance, KeenSliderOptions, useKeenSlider } from 'keen-slider/react';
import { SliderStyled, SlideStyled } from './styled';

export type SliderOptions = KeenSliderOptions;

type SliderProps = {
  children: ReactNode;
  options?: KeenSliderOptions;
  autoplayInterval?: number;
  fade?: boolean;
  className?: string;
};

const applySlidesFadeByPortion = (slider: KeenSliderInstance) => {
  slider.slides.forEach((slideElement, index) => {
    slideElement.style.opacity = String(slider.track.details.slides[index].portion);
  });
};

const withFadeOptions = (options?: KeenSliderOptions): KeenSliderOptions => ({
  ...options,
  renderMode: 'custom',
  detailsChanged: (slider) => {
    applySlidesFadeByPortion(slider);
    options?.detailsChanged?.(slider);
  },
});

export const Slider = ({ children, options, autoplayInterval, fade, className }: SliderProps) => {
  const sliderOptions = fade ? withFadeOptions(options) : options;
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>(sliderOptions);

  useEffect(() => {
    if (!autoplayInterval) return undefined;

    const intervalId = setInterval(() => {
      instanceRef.current?.next();
    }, autoplayInterval);

    return () => clearInterval(intervalId);
  }, [autoplayInterval, instanceRef]);

  return (
    <SliderStyled ref={sliderRef} className={className} $fade={fade}>
      {Children.map(children, (child) => (
        <SlideStyled className="keen-slider__slide">{child}</SlideStyled>
      ))}
    </SliderStyled>
  );
};
